// 12-point trend in the de-emphasis hue. Context for the value beside it, not a
// chart in its own right — no axes, no labels, no tooltip.
export default function Sparkline({ points }: { points: number[] }) {
  if (points.length < 2) return null;

  const width = 96;
  const height = 28;
  const max = Math.max(...points);
  const min = Math.min(...points);
  const span = max - min || 1;

  const coords = points
    .map((value, i) => {
      const x = (i / (points.length - 1)) * width;
      const y = height - ((value - min) / span) * height;
      return `${x.toFixed(1)},${y.toFixed(1)}`;
    })
    .join(' ');

  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      aria-hidden="true"
      className="overflow-visible"
    >
      <polyline
        points={coords}
        fill="none"
        stroke="#9db39f"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle
        cx={width}
        cy={height - ((points[points.length - 1] - min) / span) * height}
        r="3"
        fill="#5c7a5e"
      />
    </svg>
  );
}
